import { router } from "@inertiajs/react"
import { StepShell } from "../components/StepShell"
import { LifeWheelRadar } from "@/components/planning/LifeWheelRadar"
import { AUDIT_CATEGORIES } from "@/components/planning/audit-questions"

export function WheelReview({ data, wizard }) {
  const totals = data.quarter.wheelTotals || {}
  // The next step in this mode's order — personal_goals for the full intake,
  // peer_questions for peer_group, review for wheel_only — resolved by the
  // server (Planning::IntakeWizard#state).
  const nextStep = wizard.next || "review"
  const goNext = () => router.get(`/app/plan/intake?step=${nextStep}`)

  return (
    <StepShell
      title="Your Integrated Life Audit"
      subtitle="A snapshot of where you are right now across the six areas."
      onNext={goNext}
      nextLabel="Continue"
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-start">
        <LifeWheelRadar scores={totals} size={320} />

        <div>
          <h3 className="font-display text-lg text-zinc-900 mb-3">
            Category totals
          </h3>
          <ul className="space-y-2">
            {AUDIT_CATEGORIES.map(({ key, label }) => {
              const score = totals[key] || 0
              const pct = Math.round((score / 25) * 100)
              return (
                <li key={key}>
                  <div className="flex items-baseline justify-between text-sm">
                    <span className="text-zinc-700">{label}</span>
                    <span className="font-medium text-zinc-900">
                      {score}/25
                    </span>
                  </div>
                  <div className="h-2 bg-zinc-100 rounded-full overflow-hidden">
                    <div
                      className="h-full bg-kf-red"
                      style={{ width: `${pct}%` }}
                    />
                  </div>
                </li>
              )
            })}
          </ul>
        </div>
      </div>
    </StepShell>
  )
}
